module.exports = __webpack_public_path__ + "img/saishianpai-icon-3.090b6856.png";